module.exports = __webpack_public_path__ + "img/eyebrow_male_arched_thick.91a4236d.png";